import React from 'react'

export default function Care() {
    return (
        <>
            <h2>Jak pečovat o kobereček?</h2>
            <p>
                Kobereček{' '}
                <strong className="text-red-600 font-normal">není</strong>{' '}
                určený pro používání, jako standardní podlahové koberce. Jedná
                se spíše o designový doplněk a proto čím méně se na něj bude
                šlapat, tím méně času vezme jeho údržba.
            </p>

            <h3>Čištění</h3>
            <ul className="list-disc list-inside mt-1">
                <li>Vysání prachu vysavačem</li>
                <li>Vyprášit</li>
                <li>
                    Hrubší nečistoty mechanicky čistit trochou vody a hadříkem
                </li>
            </ul>

            <h3>Co nedělat</h3>
            <ul className="list-disc list-inside mt-1">
                <li>Neprat v pračce</li>
                <li>Nelámat kobereček</li>
            </ul>
        </>
    )
}
